<script setup lang="ts">
definePageMeta({
  custom_meta_data: {
    topic: 'integrasi',
    message: 'Saya tertarik dengan plugin Shopify KiriminAja'
  }
})

useDefaultMeta({
  title: 'Plugin Ongkos Kirim & Cek Resi Shopify dari KiriminAja',
  description:
    'Gunakan plugin ongkir Shopify gratis untuk cek ongkos kirim & resi otomatis. Integrasi mudah dengan JNE, J&T, Ninja Xpress, Gojek, dan ekspedisi lainnya!',
  robots: 'index, follow',
  schema: {
    type: ['SoftwareApplication', 'WebApplication'],
    title: 'Plugin Shopify'
  }
})

const faqs = [
  {
    question: 'Apakah plugin ini resmi untuk Shopify?',
    answer:
      'Ya, plugin KiriminAja sudah diverifikasi di Shopify App Store dan dapat digunakan untuk semua toko Shopify di Indonesia.'
  },
  {
    question:
      'Apakah bisa menampilkan ongkos kirim dari banyak ekspedisi sekaligus?',
    answer:
      'Bisa. Plugin ini mendukung berbagai ekspedisi seperti JNE, J&T Express, IDExpress, SiCepat, Ninja, Lion Parcel, dan banyak lagi.'
  },
  {
    question: 'Apakah pelanggan bisa cek resi langsung di toko saya?',
    answer:
      'Ya! Plugin otomatis menampilkan status pengiriman real-time dan bisa diakses langsung oleh pelanggan tanpa keluar dari halaman toko.'
  },
  {
    question: 'Apakah tersedia dukungan untuk COD (Cash on Delivery)?',
    answer:
      'Tersedia. Anda bisa mengaktifkan layanan COD langsung dari dashboard Shopify melalui plugin KiriminAja.'
  },
  {
    question: 'Apakah ada biaya bulanan untuk plugin ini?',
    answer: 'Tidak ada biaya bulanan, plugin ini sepenuhnya gratis digunakan.'
  }
]

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: 'KiriminAja Shopify App',
  operatingSystem: 'Shopify',
  applicationCategory: 'BusinessApplication',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: 5,
    ratingCount: 100
  },
  offers: {
    '@type': 'Offer',
    price: 0
  }
}

useHead({
  script: [
    {
      key: 'ld-software-application-shopify',
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schema)
    }
  ]
})
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Menyederhanakan Manajemen Pengiriman Toko Online"
      sub-title="Plugin Ongkir & Cek Resi Shopify"
      description="Integrasikan toko Shopify Anda dengan plugin ongkos kirim dan cek resi otomatis dari KiriminAja. Hitung ongkir real-time dari berbagai ekspedisi, buat resi otomatis, dan lacak pengiriman tanpa keluar dari dashboard Shopify."
      hero-image="/images/plugin-shopify-banner-1.webp"
    >
      <template #action>
        <div class="flex items-center gap-2 lg:gap-4 py-2">
          <UiButton
            to="https://apps.shopify.com/kiriminaja"
            label="Install Plugin"
            target="_blank"
            icon="material-symbols:download"
          />
          <UiButton
            :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
            label="Hubungi Kami"
            variant="primaryOutline"
            icon="material-symbols:call-outline"
          />
        </div>
      </template>
    </HeroBase>

    <SolusiPluginShopifyKeuntungan />
    <SolusiPluginShopifyFiturDashboard />
    <SolusiPluginShopifyCaraInstall />
    <SolusiPluginShopifyFiturDisukai />
    <PresetCourier
      title="Semua Ekspedisi Favoritmu, Siap di Shopify - KiriminAja"
      path="/solusi/plugin-shopify"
    />
    <FaqBase :faqs="faqs" />
    <SolusiPluginShopifyCta />
  </div>
</template>
